import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Formik } from 'formik'
import * as Yup from 'yup'
import InputLabel from "@material-ui/core/InputLabel";
import swal from 'sweetalert';
import DateFnsUtils from '@date-io/date-fns';
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import Select from "@material-ui/core/Select";
import MenuItem from '@material-ui/core/MenuItem';

import { Typography, FormGroup, FormControlLabel, Input } from '@material-ui/core';
import { get } from "../../../../../services/api/http.service";
import "../../../../../App.css"

import SelectReact from 'react-select';
import makeAnimated from 'react-select/animated';

const requiredField = "Campo Requerido"
const positiveNumber = "Número debe ser positivo"

let todayDate = new Date()
const animatedComponents = makeAnimated();

class DataDisplayer extends Component {

  constructor(props) {
    super(props)
    if (props.mission) {
      const { mission } = props
      this.state = { mission }
      this.state = {
        mission : {
          ...mission,
          isInvalidFile: {
            url_image: false,
          },
        },
        groups: [],
        allGroups: false,
        withoutGroups: mission.isWithoutGroup ? true : false,
        isSelectedGroups: true,
        have_question: mission.question,
        questions: mission.question_details,
        question: '',
        type_question: '',
        answers: [],
        answer_is_correct: false,
        show_answer_correct: true,
        answer: '',
        show_error_questions: false,
        backup_question: [],
        coinsByQuestions: mission.coinsByQuestions,
        canRepeat: mission.canRepeat,
        isSubmitting: false,
        sendNotification: mission.sendNotification,
        changeCoinsMode: true,
        suggested_questions: mission.suggested_questions || '',
      }

      console.log(this.state);
    } else {
      this.state = {
        mission: {
          title: "",
          statusId: 1,
          registers: 0,
          limit_registers: 0,
          social_network: "",
          social_networks_id: 0,
          qr_code_string: "",
          reward: "",
          active: true,
          description: "",
          url_target: "",
          url_id: "",
          //url_image: "",
          date_transaction: todayDate,
          deadline: todayDate,
          Rewards_id: null,
          mission_types_id: 0,
          amount: '',
          fanPages_id: 0,
          suggested_questions: '',
          isInvalidFile: {
            url_image: false,
          }
        },
        groups: [],
        allGroups: false,
        withoutGroups: false,
        isSelectedGroups: true,
        noOptionSelectedError: false,
        noGroupsSelectedError: false,
        qr_image: null,
        have_question: false,
        questions: [],
        question: '',
        type_question: '',
        answers: [],
        answer_is_correct: false,
        show_answer_correct: true,
        answer: '',
        show_error_questions: false,
        backup_question: [ ],
        coinsByQuestions: false,
        canRepeat: false,
        isSubmitting: false,
        sendNotification: false,
        changeCoinsMode: false,
      }
    }   
  }

  async componentDidMount() {
    await this.getGroups();
  }

  handleChangeFile = async (event) => {
    if(typeof event.target.files == "undefined" && event.target.files.length === 0){
        return
    }
    let file = event.target.files[0]

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      this.setState({
        ...this.state,
        qr_image: reader.result.split(',')[1]
      });

    }
  }

  questionTypeChange = (event) => {
    this.setState({
      type_question: event.target.value,
      show_answer_correct: true,
      answers: []
    })
  }

  changeQuestion = () => {
    this.setState({
      have_question: !this.state.have_question
    })
  }

  changeNotification = () => {
    this.setState({
      sendNotification: !this.state.sendNotification
    })
  }

  changeModeCoins = (event)  => {
    let value = false;
    if (event.target.value == 3) {
      value = true;
    }

    this.setState({
      coinsByQuestions: value,
      changeCoinsMode: true
    })

    if ((event.target.value == 2 || event.target.value == 3) && this.state.have_question === false) {
      this.setState({
        have_question: true
      })  
    }
  }

  changeRepeatMission = ()  => {
    this.setState({
      canRepeat: !this.state.canRepeat
    })
  }

  changeCorrect = () => {
    this.setState({
      answer_is_correct: !this.state.answer_is_correct
    })
  }

  addAnswer = () => {

    if (this.state.answer === '') {
      swal({
        title: "Respuesta inválida",
        text: "No se aceptan respuestas sin texto",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      return
    }

    let answer = {
      desc: this.state.answer
    }

    if (this.state.type_question === 'cerradaEncuesta') {
      answer.correct = true
    } else {
      answer.correct = this.state.answer_is_correct
    }

    let answers = this.state.answers
    answers.push(answer)

    if (answer.correct === true && this.state.show_answer_correct === true) {
      this.setState({
        show_answer_correct: false
      })
    }

    this.setState({
      answer: '',
      answer_is_correct: false,
      answers: answers,
    })

  }

  editAnswer = (answerParam) => {
    let answers = this.state.answers
    let actualAnswer = answers.find(answer => answer.desc === answerParam)
    let newAnswers = answers.filter(answer => answer.desc !== answerParam)

    if (this.state.answer != '') {
      let answer = {
        desc: this.state.answer,
        correct: this.state.answer_is_correct
      }

      newAnswers.push(answer)
    }

    if (actualAnswer.correct) {
      this.setState({
        show_answer_correct: true,
        answer_is_correct: true,
        answer: actualAnswer.desc
      })
    } else {
      this.setState({
        answer: actualAnswer.desc,
        show_answer_correct: false,
        answer_is_correct: false,
      })
    }

    this.setState({
      answers: newAnswers
    })
  }

  deleteAnswer = (answerParam) => {
    let answers = this.state.answers
    let deleteAnswer = answers.find(answer => answer.desc === answerParam)
    let newAnswers = answers.filter(answer => answer.desc !== answerParam)

    if (deleteAnswer.correct) {
      this.setState({
        show_answer_correct: true
      })
    }

    this.setState({
      answers: newAnswers
    })
  }

  addQuestion = () => {
    let questions = this.state.questions

    if (this.state.question === '') {
      swal({
        title: "Pregunta inválida",
        text: "No se ha escrito ninguna pregunta",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      return
    }

    if (this.state.coinsByQuestions === true && this.state.question_coins <= 0) {
      swal({
        title: "Coins inválidos",
        text: "No se ha especificado una cantidad correcta de coins",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      return
    }

    if (this.state.type_question === 'abierta' || this.state.type_question === 'abiertaEncuesta') {

      if (this.state.answer === '') {
        swal({
          title: "Pregunta inválida",
          text: "La respuesta no puede estar en blanco",
          icon: "error",
          confirmButtonColor: "#ffb133",
        })
        return
      }

      this.setState({
        answers: []
      })

      let answer = {
        desc: this.state.answer,
        correct: true
      }

      let answers = this.state.answers
      answers.push(answer)

      this.setState({
        answer: '',
        answer_is_correct: false,
        answers: answers,
      })
    }
    else if (this.state.type_question === 'cerrada' || this.state.type_question == 'cerradaEncuesta') {
      if (this.state.answers.length == 0) {
        swal({
          title: "Pregunta inválida",
          text: "La pregunta no tiene respuestas",
          icon: "error",
          confirmButtonColor: "#ffb133",
        })
        return
      }

      let valid = false
      for (const answer of this.state.answers) {
        if (answer.correct) {
          valid = true
        }
      }

      if (!valid) {
        swal({
          title: "Pregunta inválida",
          text: "La pregunta no tiene respuestas correctas",
          icon: "error",
          confirmButtonColor: "#ffb133",
        })
        return
      }
    } else {
      swal({
        title: "Pregunta inválida",
        text: "Falta especificar el tipo de pregunta",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      return
    }

    let question = {
      desc: this.state.question,
      type: this.state.type_question,
      answers: this.state.answers
    }

    if (this.state.coinsByQuestions === true) {
      question.coins = this.state.question_coins
    }

    questions.push(question)

    this.setState({
      questions: questions,
      question: '',
      type_question: '',
      answers: [],
      answer_is_correct: false,
      show_answer_correct: true,
      answer: '',
      show_error_questions: false,
      question_coins: 0
    })
  }

  editQuestion = (questionParam) => {
    let questions = this.state.questions
    let actualQuestion = questions.filter(question => question.desc === questionParam)
    let newQuestions = questions.filter(question => question.desc !== questionParam)
    actualQuestion = actualQuestion[0]

    if (actualQuestion.type === 'abierta' || actualQuestion.type === 'abiertaEncuesta') {
      this.setState({
        answer: actualQuestion.answers[0].desc
      })
    } else {
      this.setState({
        answers: actualQuestion.answers
      })
    }

    if (this.state.backup_question.length > 0) {
      newQuestions.push(this.state.backup_question)
      this.setState({
        backup_question: [ ]
      })
    }

    if (this.state.coinsByQuestions === true) {
      this.setState({
        question: actualQuestion.desc,
        type_question: actualQuestion.type,
        show_answer_correct: false,
        questions: newQuestions,
        backup_question: actualQuestion,
        question_coins: actualQuestion.coins
      })
    } else {
      this.setState({
        question: actualQuestion.desc,
        type_question: actualQuestion.type,
        show_answer_correct: false,
        questions: newQuestions,
        backup_question: actualQuestion,
      })
    }
  }

  deleteQuestion = (questionParam) => {
    let questions = this.state.questions
    let newQuestions = questions.filter(question => question.desc !== questionParam)

    this.setState({
      questions: newQuestions
    })
  }

  typeAnswerText = (event, option) => {
    if (option === 1) {
      this.setState({
        question: event.target.value
      })
    } else if (option === 2) {
      this.setState({
        answer: event.target.value
      })
    } else if (option === 3) {
      this.setState({
        question_coins: event.target.value
      })
    }
  }

  getGroups = async () => {
    try {
      let missionId = typeof this.state.mission.id != "undefined" && this.state.mission.id != null ? this.state.mission.id : 0
      let response = null;
      if (localStorage.getItem('admin') == '1') {
        response = await get("groups/mission/" + missionId)
      } else {
        response = await get("groups/mission/" + missionId + "/" + localStorage.getItem('client_id'))
      }
      if (response.success) {
        //const data = response.rows.filter(({ active }) => !!active);
        let findedGroup = response.rows.filter(row => row.isSelectedInMission == false)
        let isAnyGroupSelected = response.rows.filter(row => row.isSelectedInMission == true)
        const data = response.rows;
        this.setState({
          ...this.state,
          ["groups"]: data,
          ["allGroups"]: findedGroup.length > 0 ? false : true,
          ["isSelectedGroups"]: true
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleSubmit = (values, actions) => { 

    this.setState({
      isSubmitting: true
    })

    if (this.state.coinsByQuestions === null) {
      swal({
        title: "Pregunta inválida",
        text: "Valide como otorgar coins en la misión",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }

    if (this.state.coinsByQuestions === false && (values.amount <= 0 || values.amount === '')) {
      swal({
        title: "Pregunta inválida",
        text: "Valide los coins de la misión",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }

    if (this.state.coinsByQuestions === true) {

      console.log('DENTRO');
      let count = 0;
      let questions = this.state.questions

      if (questions.length <= 0) {
        swal({
          title: "Error",
          text: "No se han agregado preguntas a la misión",
          icon: "error",
          confirmButtonColor: "#ffb133",
        })
        return;
      }

      questions.forEach(question => {
        console.log(question);
        count += parseInt(question.coins)
      });

      values.amount = parseInt(count)
    }
    // Validaciones adicionales
    this.setState({
      ...this.state,
      noOptionSelectedError: false,
      noGroupsSelectedError: false
    })

    if (this.state.groups.length == 0) {
      swal({
        title: "Error",
        text: "No hay grupos disponibles para la misión",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }

    //check selected groups
    let selectedGroups = this.state.groups.filter(row => row.isSelectedInMission == true)
    if (selectedGroups.length == 0) {
      swal({
        title: "Error",
        text: "No se han seleccionado grupos para la misión",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }

    //check if coins by questions is selected
    if (!this.state.changeCoinsMode) {
      swal({
        title: "Error",
        text: "No se han configurado el método de asignación de puntos",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }

    //Check url
    if (values.mission_types_id !== 9) {
      if (values.url_target === '' || values.url_target === '') {
        swal({
          title: "Error",
          text: "No se ha ingresado una URL válida para la misión",
          icon: "error",
          confirmButtonColor: "#ffb133",
        })
        actions.setSubmitting(false);
        this.setState({
          isSubmitting: false
        })
        return; 
      }
    }

    if (this.state.have_question && this.state.questions.length == 0) {
      this.setState({
        show_error_questions: true
      })

      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }

    if(values.title.length > 40) {
      swal({
        title: "Error",
        text: "El titulo excede los 40 caracteres permitidos",
        icon: "error",
        confirmButtonColor: "#ffb133",
      })
      actions.setSubmitting(false);
      this.setState({
        isSubmitting: false
      })
      return;
    }
    
    values.canRepeat = this.state.canRepeat
    values.client_id = localStorage.getItem('client_id')
   
    if (typeof values.date_transaction != "string") {
      var isoDateTime = new Date(values.date_transaction.getTime() - (values.date_transaction.getTimezoneOffset() * 60000)).toISOString();
      values.date_transaction = isoDateTime;
    }
    
    if (typeof values.deadline != "string") {
      var isoDateTime2 = new Date(values.deadline.getTime() - (values.deadline.getTimezoneOffset() * 60000)).toISOString();
      values.deadline = isoDateTime2;
    }

    this.props.handleSubmit(
      values, 
      this.state.groups, 
      this.state.allGroups, 
      this.state.withoutGroups, 
      this.state.qr_image,
      this.state.have_question,
      { questions: this.state.questions },
      this.state.coinsByQuestions,
    ) 
    
    actions.setSubmitting(false);

    this.setState({
      isSubmitting: false
    })
  }

  handleCancel = (values) => {
    this.props.onCancel(values)
  }

  handleCheckGroup = event => {
    let id = event.target.id
    let tempGroups = this.state.groups
    for(let group of tempGroups){
        if(group.id == id){
          group.isSelectedInMission = event.target.checked
        }
    }
    //let findedGroup = tempGroups.find(row => row.id == id)
    //findedGroup
    this.setState({
      ...this.state,
      ["groups"]: tempGroups,
      ["withoutGroups"]: event.target.checked ? false : this.state.withoutGroups,
      ["allGroups"]: event.target.checked == false ? false : this.state.allGroups,
    });
  }

  handleCheckGroupSelect = event => {
    let flag;
    let eventGroups = event
    if(typeof event == "undefined" || event == null){
      eventGroups = []
    }
    let id;
    if(eventGroups.length > 0){
      id = eventGroups[eventGroups.length-1].id
    }
    let tempGroups = this.state.groups
    for(let group of tempGroups){
      if(typeof eventGroups.find(row => row.id == group.id) != "undefined"){
        flag = true
      }
      group.isSelectedInMission = typeof eventGroups.find(row => row.id == group.id) != "undefined" ? true : false
    }
    this.setState({
      ...this.state,
      ["groups"]: tempGroups,
    });
  }
  
  handleWithGroup = event => {
    if(event.target.checked){
      let tempGroups = this.state.groups
      for(let group of tempGroups){
        group.isSelectedInMission = false
      }
      this.setState({
        ...this.state,
        ["withoutGroups"]: false,
        ["allGroups"]: false,
        ["isSelectedGroups"]: event.target.value
      });
    } else {
      this.setState({
        ...this.state,
        ["isSelectedGroups"]: event.target.value
      });
    }
  }

  getSelectedGroups = () => {
    if (this.state.groups.length == 0) {
      return [];
    }
    let selecteds = [];

    this.state.groups.filter(row => row.isSelectedInMission == true).map(row => {
      selecteds.push({
        id: row.id,
        label: row.name,
        value: row.name
      })
    })

    console.log(selecteds);
    return selecteds;
  }

  render(){
    const { mission } = this.state
    const { social_networks } = this.props
    const { rewards } = this.props;
    const { mission_types } = this.props
    const { status } = this.props
    const { fan_pages } = this.props
    const questionsLocked = mission && mission.registers > 0;

    
    let date = new Date(mission.date_transaction)
    var isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    mission.date_transaction = isoDateTime;

    date = new Date(mission.deadline)
    var isoDateTime2 = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    mission.deadline = isoDateTime2;

    return (
      <Formik
        initialValues={mission}
        onSubmit={this.handleSubmit}
        validationSchema={Yup.object().shape({
          social_networks_id: Yup.number()
            .min(1, "Selecciona una tipo de misión")
            .required(requiredField),
          title: Yup.string()
            .required(requiredField),
          mission_types_id: Yup.number()
            .min(1, "Selecciona un tipo de misión")
            .required(requiredField),
          date_transaction: Yup.date()
            .required(requiredField),
          deadline: Yup.date()
            .min(Yup.ref('date_transaction'), "Fecha Fin no puede ser menor a Fecha Operación")
            .required(requiredField),
          description: Yup.string()
            .required(requiredField),
        })}
      >
                
        {props => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit
          } = props

          const changeFile = (name, e) => {
            const fileName = e.target.files[0].name
            e.persist()
            if (!(/\.(jpg|png|gif)$/i).test(fileName)) {
              swal({
                title: "Archivo inválido",
                text: "El formato del archivo no es válido y no se subirá",
                icon: "error",
                confirmButtonColor: "#ffb133",
              })
              values.isInvalidFile[name] = true
              this.forceUpdate()
            }
            else {
              values[name] = e.target.files[0]
              this.forceUpdate()
            }
          }        

          return (
            <form className="mt-4" autoComplete='off' onSubmit={handleSubmit}>              
              <div className='d-flex align-middle mb-2'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M16 15C20.009 14.935 23 11.967 23 8C23 4.988 22.003 5.985 21 7C20.009 7.98 18 10 18 10L14 6C14 6 16.02 3.991 17 3C18.015 1.997 18.015 1 16 1C12.033 1 9.05295 3.991 8.99995 8C9.04195 8.976 8.99995 11 8.99995 11C7.11495 12.897 4.65995 15.353 2.99995 17C0.0679535 19.944 4.05595 23.932 6.99995 21C8.64995 19.338 11.113 16.875 13 15C13 15 15.024 14.958 16 15Z" stroke="#FF4F00" strokeWidth="2"/>
                </svg>
                <span className='missionSecondaryTitle'>1. ¡Vamos a configurar tu misión!</span>
              </div>

              <div className="row mb-md-3 mt-3">
                <div className="col-lg-6 col-sm-6 col-12">
                  <FormControl fullWidth error={ Boolean(touched.social_networks_id && (errors.social_networks_id)) }>
                    <span className="inputTitle">Tipo de misión</span>
                    <span className="inputSubtitle">Elige el tipo de misión que mejor se ajuste a lo que buscas.</span>
                      <Select
                        fullWidth
                        id="outlined-text-input"
                        label="Plataforma"
                        type="text"
                        name="social_networks_id"
                        inputProps={{ maxLength: 128, readOnly: this.props.readOnly || values.statusId == 2}}
                        onBlur={handleBlur}
                        error={errors.social_networks_id && touched.social_networks_id}
                        helpertext={touched.social_networks_id && (errors.social_networks_id)}
                        className={errors.social_networks_id && touched.social_networks_id && "error"}
                        value={values.social_networks_id}
                        onChange={handleChange}
                        style={{ border: '1px solid', borderRadius: '8px', padding: '8px 16px'}}
                      >
                      { social_networks ? social_networks.map( (social_network) => {
                        return (
                          <MenuItem value={social_network.id} key={social_network.id}> 
                              {
                                social_network.id === 3 ?
                                <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                  <b>{social_network.name}</b>
                                  <br />
                                  <small style={{ fontWeight: 400, color: '#666' }}>
                                    Perfecta para actividades que se realizan en el entorno digital. Esto puede incluir visitar
                                  </small>
                                  <br />
                                  <small style={{ fontWeight: 400, color: '#666' }}>
                                    un sitio web, completar cuestionarios, o participar en actividades específicas
                                  </small>
                                  <br />
                                  <small style={{ fontWeight: 400, color: '#666' }}>
                                    en plataformas como Spotify y X.
                                  </small>
                                </Typography> :
                                <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                  <b>{social_network.name}</b>
                                  <br />
                                  <small style={{ fontWeight: 400, color: '#666' }}>
                                    Ideal para misiones que requieren la interacción física en un lugar determinado. Por 
                                  </small>
                                  <br />
                                  <small style={{ fontWeight: 400, color: '#666' }}>
                                    ejemplo, los participantes pueden necesitar escanear un código QR en una
                                  </small>
                                  <br />
                                  <small style={{ fontWeight: 400, color: '#666' }}>
                                    ubicación específica o hacer una visita en persona.
                                  </small>
                                </Typography>
                              }
                              
                          </MenuItem>
                        )
                      }) : null
                      }
                    </Select>
                    {
                      touched.social_networks_id && (errors.social_networks_id) && <FormHelperText>{ errors.social_networks_id }</FormHelperText>
                    }
                  </FormControl>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <FormControl fullWidth error={ Boolean(touched.mission_types_id && (errors.mission_types_id)) }>
                    <span className="inputTitle">Tipo de actividad</span>
                    <span className="inputSubtitle">Selecciona cómo se llevará a cabo la misión.</span>
                    <Select
                      fullWidth
                      id="outlined-text-input"
                      label="Tipo de misión"
                      type="text"
                      name="mission_types_id"
                      inputProps={{ maxLength: 128, readOnly: this.props.readOnly }}
                      onBlur={handleBlur}
                      error={errors.mission_types_id && touched.mission_types_id}
                      helpertext={touched.mission_types_id && (errors.mission_types_id)}
                      className={errors.mission_types_id && touched.mission_types_id && "error"} 
                      value={values.mission_types_id}
                      onChange={handleChange}
                      style={{ border: '1px solid', borderRadius: '8px', padding: '8px 16px'}}
                    >
                    { 
                      (mission_types && values.social_networks_id != 0) ? mission_types.filter(mission_type => values.social_networks_id !== 0 ? mission_type.social_networks_id === values.social_networks_id : true )
                            .map((mission_type) => 
                            <MenuItem value={mission_type.id} key={mission_type.id}>
                              <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <b>{mission_type.name}</b>
                                {
                                  mission_type.social_networks_id != 3 ?
                                    mission_type.id === 9 &&
                                      (
                                      <div>
                                        <small style={{ fontWeight: 400, color: '#666' }}>
                                          Activa la aventura en el mundo real. Los usuarios deben localizar y escanear un 
                                        </small>
                                        <br />
                                        <small style={{ fontWeight: 400, color: '#666' }}>
                                          código QR en un lugar designado, lo que puede redirigirlos a una URL o verificar su 
                                        </small>
                                        <br />
                                        <small style={{ fontWeight: 400, color: '#666' }}>
                                          visita.
                                        </small>
                                      </div>
                                      ) :  mission_type.id === 11 &&
                                      (
                                        <div>
                                          <small style={{ fontWeight: 400, color: '#666' }}>
                                            Navega por el mundo digital descubriendo sitios web, documentos en la nube, y 
                                          </small>
                                          <br />
                                          <small style={{ fontWeight: 400, color: '#666' }}>
                                            más, a través de URLs. Ideal para enriquecer el conocimiento o la experiencia digital.
                                          </small>
                                        </div>
                                      )
                                }
                              </Typography>                                                        
                            </MenuItem>) 
                          : null
                    }
                    </Select>
                    {
                      touched.mission_types_id && (errors.mission_types_id) && <FormHelperText>{ errors.mission_types_id }</FormHelperText>
                    }
                  </FormControl>
                </div>
              </div>

              <div className='d-flex align-middle mb-2'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M4.25 4C3.65326 4 3.08097 4.23705 2.65901 4.65901C2.23705 5.08097 2 5.65326 2 6.25V8.75C2 9.34674 2.23705 9.91903 2.65901 10.341C3.08097 10.7629 3.65326 11 4.25 11H6.75C7.34674 11 7.91903 10.7629 8.34099 10.341C8.76295 9.91903 9 9.34674 9 8.75V6.25C9 5.65326 8.76295 5.08097 8.34099 4.65901C7.91903 4.23705 7.34674 4 6.75 4H4.25ZM3.5 6.25C3.5 6.05109 3.57902 5.86032 3.71967 5.71967C3.86032 5.57902 4.05109 5.5 4.25 5.5H6.75C6.94891 5.5 7.13968 5.57902 7.28033 5.71967C7.42098 5.86032 7.5 6.05109 7.5 6.25V8.75C7.5 8.94891 7.42098 9.13968 7.28033 9.28033C7.13968 9.42098 6.94891 9.5 6.75 9.5H4.25C4.05109 9.5 3.86032 9.42098 3.71967 9.28033C3.57902 9.13968 3.5 8.94891 3.5 8.75V6.25ZM11.25 5C11.0511 5 10.8603 5.07902 10.7197 5.21967C10.579 5.36032 10.5 5.55109 10.5 5.75C10.5 5.94891 10.579 6.13968 10.7197 6.28033C10.8603 6.42098 11.0511 6.5 11.25 6.5H21.25C21.4489 6.5 21.6397 6.42098 21.7803 6.28033C21.921 6.13968 22 5.94891 22 5.75C22 5.55109 21.921 5.36032 21.7803 5.21967C21.6397 5.07902 21.4489 5 21.25 5H11.25ZM11.25 8C11.0511 8 10.8603 8.07902 10.7197 8.21967C10.579 8.36032 10.5 8.55109 10.5 8.75C10.5 8.94891 10.579 9.13968 10.7197 9.28033C10.8603 9.42098 11.0511 9.5 11.25 9.5H18.25C18.4489 9.5 18.6397 9.42098 18.7803 9.28033C18.921 9.13968 19 8.94891 19 8.75C19 8.55109 18.921 8.36032 18.7803 8.21967C18.6397 8.07902 18.4489 8 18.25 8H11.25ZM4.25 13C3.65326 13 3.08097 13.2371 2.65901 13.659C2.23705 14.081 2 14.6533 2 15.25V17.75C2 18.0455 2.0582 18.3381 2.17127 18.611C2.28434 18.884 2.45008 19.1321 2.65901 19.341C2.86794 19.5499 3.11598 19.7157 3.38896 19.8287C3.66194 19.9418 3.95453 20 4.25 20H6.75C7.04547 20 7.33806 19.9418 7.61104 19.8287C7.88402 19.7157 8.13206 19.5499 8.34099 19.341C8.54992 19.1321 8.71566 18.884 8.82873 18.611C8.9418 18.3381 9 18.0455 9 17.75V15.25C9 14.6533 8.76295 14.081 8.34099 13.659C7.91903 13.2371 7.34674 13 6.75 13H4.25ZM3.5 15.25C3.5 15.0511 3.57902 14.8603 3.71967 14.7197C3.86032 14.579 4.05109 14.5 4.25 14.5H6.75C6.94891 14.5 7.13968 14.579 7.28033 14.7197C7.42098 14.8603 7.5 15.0511 7.5 15.25V17.75C7.5 17.9489 7.42098 18.1397 7.28033 18.2803C7.13968 18.421 6.94891 18.5 6.75 18.5H4.25C4.05109 18.5 3.86032 18.421 3.71967 18.2803C3.57902 18.1397 3.5 17.9489 3.5 17.75V15.25ZM11.25 14C11.0511 14 10.8603 14.079 10.7197 14.2197C10.579 14.3603 10.5 14.5511 10.5 14.75C10.5 14.9489 10.579 15.1397 10.7197 15.2803C10.8603 15.421 11.0511 15.5 11.25 15.5H21.25C21.4489 15.5 21.6397 15.421 21.7803 15.2803C21.921 15.1397 22 14.9489 22 14.75C22 14.5511 21.921 14.3603 21.7803 14.2197C21.6397 14.079 21.4489 14 21.25 14H11.25ZM11.25 17C11.0511 17 10.8603 17.079 10.7197 17.2197C10.579 17.3603 10.5 17.5511 10.5 17.75C10.5 17.9489 10.579 18.1397 10.7197 18.2803C10.8603 18.421 11.0511 18.5 11.25 18.5H18.25C18.4489 18.5 18.6397 18.421 18.7803 18.2803C18.921 18.1397 19 17.9489 19 17.75C19 17.5511 18.921 17.3603 18.7803 17.2197C18.6397 17.079 18.4489 17 18.25 17H11.25Z" fill="#FF4F00"/>
                </svg>
                <span className='missionSecondaryTitle'>2. Detalles de la misión</span>
              </div>
              <div className="row mb-md-3">
                <div className="col-lg-12 col-sm-12 col-12">
                  <span className="inputTitle">Título de la misión</span>
                  <br />
                  <span className="inputSubtitle">
                    Define el nombre de tu misión. Elige un título breve pero descriptivo que resuma el objetivo o la actividad a realizar.
                  </span>
                  <TextField
                    fullWidth
                    id="outlined-text-input"
                    type="text"
                    name="title"
                    inputProps={{ maxLength: 40, readOnly: this.props.readOnly }}
                    onBlur={handleBlur}
                    error={errors.title && touched.title}
                    helpertext={touched.title && (errors.title)}
                    className={errors.title && touched.title && "error"}
                    value={values.title}
                    onChange={handleChange}
                    maxlength={40}
                    label="Ejemplo: 'Caza de Tesoro Digital'"
                  />
                </div>
                <div className="col-lg-12 col-sm-12 col-12 mt-4">
                  <FormControl fullWidth>
                    <span className="inputTitle">Instrucciones</span>
                    <span className="inputSubtitle">
                      Proporciona los pasos específicos que los usuarios deben seguir para completar la misión. Sé claro y conciso para evitar confusiones.
                    </span>
                    <TextareaAutosize
                      className="rounded mt-2"
                      readOnly={this.props.readOnly}
                      value={values.description}
                      name="description"
                      type="text"
                      minRows={4}
                      maxLength={200}
                      onChange={handleChange}
                      placeholder="Ejemplo: 1. Visita la ubicacion indicada 2. Escanea el codigo QR 3. Sigue las instrucciones en pantalla para finalizar"
                    />
                    {errors.description && touched.description && (<FormHelperText error={errors.description && touched.description}>{errors.description}</FormHelperText>)}
                  </FormControl>     
                </div>
                {
                  values.mission_types_id === 9 ? null : (
                    <div className="col-lg-12 col-sm-12 col-12 mt-4">
                      {
                        values.social_networks_id == 3 && values.mission_types_id == 11 ? 
                        <div>
                          <span className="inputTitle">Contenido</span>
                          <br />
                          <span className="inputSubtitle">
                            Copia y pega la dirección electrónica del contenido, puede ser un website, un video, formulario o cualquier material digital en la nube.
                          </span>
                        </div> :
                        <div>
                          <span className="inputTitle">Recurso spotify</span>
                          <br />
                          <span className="inputSubtitle">
                            Indica la URL de Spotify para la acción que los usuarios deben realizar. Asegúrate de utilizar el enlace de la sección "Compartir { '>' } Copiar URL" de Spotify.
                          </span>
                        </div>
                      }
                      
                      <TextField
                        fullWidth
                        id="outlined-text-input"
                        //label="Nombre"
                        label={ values.mission_types_id == 11 ? "http://ejemplo.com o https://ejemplo.com" : "https://open.spotify.com/track/ID?si=CODIGO" }
                        type="text"
                        //name="name"
                        name="url_target"
                        inputProps={{ maxLength: 128, readOnly: this.props.readOnly }}
                        onBlur={handleBlur}
                        error={errors.url_target && touched.url_target}
                        helperText={touched.url_target && (errors.url_target)}
                        className={errors.url_target && touched.url_target && "error"}
                        value={values.url_target}
                        onChange={(event) => {
                          handleChange(event)
                          console.log(event);
                          if (values.mission_types_id == 7 || values.mission_types_id == 8 || values.mission_types_id == 10) {
                            console.log('entre');
                            let url = event.target.value
                            let urlSplit = url.split('/')
                            let spotifyData = urlSplit[urlSplit.length - 1]

                            //remover code
                            let code = spotifyData.split('?')
                            spotifyData = code[0]


                            //formato spotify
                            let spotify = 'spotify:';
                            if (values.mission_types_id === 7) {
                              spotify += 'track:';
                            } else if (values.mission_types_id === 8) {
                              spotify += 'podcast:';
                            } else if (values.mission_types_id === 10) {
                              spotify += 'artist:';
                            }
                            spotify += spotifyData

                            if (spotifyData.length > 0) {
                              handleChange({
                                target: {
                                  name: 'url_target',
                                  value: spotify
                                }
                              });
  
                              handleChange({
                                target: {
                                  name: 'url_id',
                                  value: spotifyData
                                }
                              });
                            } else {
                              handleChange({
                                target: {
                                  name: 'url_id',
                                  value: ''
                                }
                              });
                            }
                          }
                        }}
                      />
                      {errors.url_target && touched.url_target && (<FormHelperText error={errors.url_target && touched.url_target}>{errors.url_target}</FormHelperText>)}
                    </div>
                  )
                }
                <div className="col-lg-12 col-sm-12 col-12 mt-4 d-none">
                  <span className="inputTitle">URL corta</span>
                  <br />
                  <span className="inputSubtitle">
                    Escribe el contenido de la URL sin el dominio de la plataforma.
                  </span>
                  <TextField
                    fullWidth
                    disabled={values.social_networks_id == 3}
                    id="outlined-text-input"
                    type="text"
                    name="url_id"
                    inputProps={{ maxLength: 128, readOnly: this.props.readOnly }}
                    onBlur={handleBlur}
                    error={errors.url_id && touched.url_id}
                    helperText={touched.url_id && (errors.url_id)   }
                    className={errors.url_id && touched.url_id && "error"}
                    value={values.url_id}
                    // value={ values.fanPages_id !== 0 ? "https://www.facebook.com/" + fan_pages.filter(fan_page => fan_page.id === values.fanPages_id)[0].idFacebook + "_" + values.url_id : "" } 
                    onChange={handleChange}
                  />
                  {errors.url_id && touched.url_id && (<FormHelperText error={errors.url_id && touched.url_id}>{errors.url_id}</FormHelperText>)}
                </div>
                { 
                  values.mission_types_id === 9 &&
                    <div className="col-lg-12 col-sm-12 col-12 mt-4">
                      <span className="inputTitle">Contenido del QR</span>
                      <br />
                      <span className="inputSubtitle">
                        Introduce el contenido específico del código QR que será validado. Si el contenido requiere que el usuario visite una URL, asegúrate de que el texto comience con "http" o "https".
                      </span>
                      <TextField
                        fullWidth
                        id="outlined-text-input"
                        //label="Nombre"
                        label="textodelqr o http://ejemplo.com o https://ejemplo.com"
                        type="text"
                        //name="name"
                        name="qr_code_string"
                        inputProps={{ maxLength: 128, readOnly: this.props.readOnly }}
                        onBlur={handleBlur}
                        error={errors.qr_code_string && touched.qr_code_string}
                        helperText={touched.qr_code_string && (errors.qr_code_string)}
                        className={errors.qr_code_string && touched.qr_code_string && "error"}
                        value={values.qr_code_string}
                        onChange={handleChange}
                      />
                    </div>            
                }
                {/*
                  values.mission_types_id === 9 &&
                    <div className="col-lg-6 col-sm-12 col-6 mt-4">
                      <span className="inputTitle">Imagen QR</span>
                      <br />
                      {
                        !this.props.readOnly &&
                        <p className="inputSubtitle">
                          Sube una imagen del código QR que será validado. Asegúrate de que la imagen sea clara y legible para que los usuarios puedan escanearla sin problemas.
                        </p>
                      }
                      {
                        this.props.readOnly ? (
                            <img className="qr" src={`${process.env.REACT_APP_STORAGE}/missions/${values.qr_code_path}`} />
                          ) 
                        : (<Input
                          type="file"
                          inputProps={{
                            accept: ".png",
                          }}
                          onChange={this.handleChangeFile}
                          disableUnderline={true}
                        />)
                      }
                      
                    </div>
                */}
              </div>

              <div className='d-flex align-middle mb-2'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M3.00002 9.96191V4.46191H21V9.96191H20V5.46191H4.00002V9.96191H3.00002ZM3.00002 17.4619V10.9619H4.00002V16.4619H20V10.9619H21V17.4619H3.00002ZM3.00002 10.9619V9.96191H8.31202L10.075 13.4719L13.675 6.99991H14.337L15.817 9.96191H21V10.9619H15.202L13.95 8.48991L10.306 14.9619H9.68302L7.68302 10.9619H3.00002ZM1.77002 19.4619V18.4619H22.23V19.4619H1.77002Z" fill="#FF4F00"/>
                </svg>
                <span className='missionSecondaryTitle'>3. Programación y participación</span>
              </div>

              <div className="row mb-md-3">
                <div className="col-lg-6 col-sm-6 col-12">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} className="border">
                    <span className="inputTitle">Fecha de inicio de la misión</span>
                    <br />
                    <span className="inputSubtitle">A partir de esta fecha se hará visible la misión a los usuarios.</span>
                    <KeyboardDateTimePicker
                      fullWidth
                      format="dd/MM/yyyy HH:mm"
                      margin="normal"
                      label="DD/MM/AAAA HH:MM"
                      disablePast
                      readOnly={this.props.readOnly}
                      onBlur={handleBlur}
                      error={errors.date_transaction && touched.date_transaction}
                      helpertext={touched.date_transaction && (errors.date_transaction)}
                      className={errors.date_transaction && touched.date_transaction && "error"}
                      name="date_transaction"
                      value={values.date_transaction}
                      InputProps={{ readOnly: this.props.readOnly }}
                      onChange={date => {
                        date = date ? new Date(date) : date
                        values.date_transaction = date
                        this.forceUpdate()
                      }}
                      ampm={false}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <span className="inputTitle">Fecha limite para completar la misión</span>
                    <br />
                    <span className="inputSubtitle">Después de esta fecha los usuarios ya no pordrán resolver la misión</span>
                    <KeyboardDateTimePicker
                      fullWidth
                      format="dd/MM/yyyy HH:mm"
                      margin="normal"
                      //disableFuture={false}
                      disablePast
                      readOnly={this.props.readOnly}
                      onBlur={handleBlur}
                      error={errors.deadline && touched.deadline}
                      helpertext={touched.deadline && (errors.deadline)}
                      className={errors.deadline && touched.deadline && "error"}
                      name="deadline"
                      InputProps={{ readOnly: this.props.readOnly }}
                      value={values.deadline}
                      ampm={false}
                      label="DD/MM/AAAA HH:MM"
                      onChange={date => {
                        values.deadline = date
                        this.forceUpdate()
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                    </MuiPickersUtilsProvider>
                </div>

                <div className="col-lg-6 col-sm-6 col-12 mt-3">
                  <span className="inputTitle">Limite de ganadores</span>
                  <br />
                  <span className="inputSubtitle">
                    Fija un número máximo de participantes para la misión. Esto te ayuda a gestionar la disponibilidad y exclusividad de la experiencia.
                  </span>
                  <TextField
                    fullWidth
                    id="outlined-text-input"
                    type="number"
                    name="limit_registers"
                    inputProps={{ readOnly: this.props.readOnly }}
                    onBlur={handleBlur}
                    label="Sin limite"
                    error={errors.limit_registers && touched.limit_registers}
                    helpertext={touched.limit_registers && (errors.limit_registers)}
                    className={errors.limit_registers && touched.limit_registers && "error"}
                    value={values.limit_registers}
                    onChange={handleChange}
                  />
                  {errors.limit_registers && touched.limit_registers && (<FormHelperText error={errors.limit_registers && touched.limit_registers}>{errors.limit_registers}</FormHelperText>)}
                </div>
                <div className="col-lg-6 col-sm-6 col-12 mt-3">
                  <span className="inputTitle">Grupos de usuarios</span>
                  <br />
                  <span className="inputSubtitle mb-2">
                    Elige los grupos de usuarios habilitados para participar en esta misión, lo cual te permite dirigirla a audencias especificas.
                  </span>
                  <SelectReact
                    className="mt-2"
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    options={this.state.groups.map( group => {
                      return {value: group.name, label: group.name, id: group.id}
                    })}
                    value={this.state.groups.map( group => {
                      if (group.isSelectedInMission) {
                        return {value: group.name, label: group.name, id: group.id} 
                      }
                    })}
                    placeholder="Seleccionar grupos"
                    isMulti
                    onChange={this.handleCheckGroupSelect}
                    isDisabled={this.props.readOnly}
                  />
                </div>
              </div>

              <div
                style={{
                  background: '#fff8f0',
                  border: '2px solid #e8720c',
                  borderRadius: '8px',
                  padding: '16px 20px',
                  marginBottom: '24px',
                }}
              >
                <span className="inputTitle" style={{ color: '#c45c00' }}>Preguntas y respuestas definidas</span>
                <br />
                <span className="inputSubtitle" style={{ color: '#7a3800' }}>
                  Las siguientes preguntas y respuestas se obtienen desde Envoz Website y deben utilizarse tal como se muestran:
                </span>
                <TextareaAutosize
                  disabled={true}
                  minRows={3}
                  style={{
                    width: '100%',
                    marginTop: '10px',
                    border: '1px solid #e8720c',
                    borderRadius: '6px',
                    padding: '8px',
                    fontFamily: 'inherit',
                    fontSize: '14px',
                    resize: 'vertical',
                    backgroundColor: this.props.readOnly ? '#f5f5f5' : 'white',
                  }}
                  value={values.suggested_questions || ''}
                  name="suggested_questions"
                  onChange={handleChange}
                  readOnly={this.props.readOnly}
                  placeholder="Escribe aquí las preguntas sugeridas..."
                />
              </div>

              <div className='d-flex align-middle mb-2'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 11C12.55 11 13.021 10.8043 13.413 10.413C13.805 10.0217 14.0007 9.55067 14 9C14 8.45 13.8043 7.97933 13.413 7.588C13.0217 7.19667 12.5507 7.00067 12 7C11.45 7 10.9793 7.196 10.588 7.588C10.1967 7.98 10.0007 8.45067 10 9C10 9.55 10.196 10.021 10.588 10.413C10.98 10.805 11.4507 11.0007 12 11ZM11.5 19V15.246C10.5807 15.178 9.78067 14.845 9.1 14.247C8.42 13.649 7.99433 12.896 7.823 11.988C6.76567 11.864 5.864 11.4307 5.118 10.688C4.37267 9.94467 4 9.04867 4 8V7.615C4 7.171 4.15833 6.791 4.475 6.475C4.791 6.15833 5.171 6 5.615 6H7.654V5.615C7.654 5.171 7.812 4.791 8.128 4.475C8.44467 4.15833 8.82533 4 9.27 4H14.732C15.176 4 15.556 4.15833 15.872 4.475C16.1887 4.791 16.347 5.171 16.347 5.615V6H18.386C18.83 6 19.21 6.15833 19.526 6.475C19.8427 6.791 20.001 7.171 20.001 7.615V8C20.001 9.04867 19.6283 9.94467 18.883 10.688C18.137 11.4307 17.2353 11.864 16.178 11.988C16.006 12.896 15.58 13.6493 14.9 14.248C14.22 14.8453 13.4203 15.178 12.501 15.246V19H15.116C15.258 19 15.377 19.048 15.473 19.144C15.569 19.24 15.6167 19.359 15.616 19.501C15.616 19.6423 15.5683 19.761 15.473 19.857C15.377 19.9523 15.258 20 15.116 20H8.886C8.744 20 8.625 19.952 8.529 19.856C8.43367 19.76 8.386 19.641 8.386 19.499C8.386 19.3577 8.43367 19.239 8.529 19.143C8.625 19.0477 8.744 19 8.886 19H11.5ZM7.654 10.915V7H5.615C5.43567 7 5.28833 7.05767 5.173 7.173C5.05767 7.28833 5 7.43567 5 7.615V8C5 8.74867 5.254 9.39967 5.762 9.953C6.26933 10.5063 6.9 10.827 7.654 10.915ZM12.004 14.269C12.924 14.269 13.7047 13.9473 14.346 13.304C14.9873 12.6613 15.308 11.8807 15.308 10.962V5.615C15.308 5.43567 15.2503 5.28833 15.135 5.173C15.0197 5.05767 14.872 5 14.692 5H9.308C9.128 5 8.98033 5.05767 8.865 5.173C8.74967 5.28833 8.692 5.43567 8.692 5.615V10.962C8.692 11.8807 9.014 12.6613 9.658 13.304C10.302 13.9473 11.0843 14.269 12.005 14.269M16.346 10.915C17.0993 10.827 17.73 10.5063 18.238 9.953C18.746 9.39967 19 8.74867 19 8V7.615C19 7.43567 18.9423 7.28833 18.827 7.173C18.7117 7.05767 18.5643 7 18.385 7H16.346V10.915Z" fill="#FF4F00"/>
                </svg>
                <span className='missionSecondaryTitle'>4. Configuración de recompensas</span>
              </div>

              <div className="row mb-md-3">
                <div className="col-lg-6 col-sm-6 col-12">
                  <FormControl fullWidth>
                    <span className="inputTitle">Método de asignación de puntos</span>
                    <span className="inputSubtitle">
                      Define si los participantes ganarán puntos al completar la misión o si se asignarán por cada pregunta correcta respondida.
                    </span>
                    <Select
                      fullWidth
                      id="outlined-text-input"
                      label="Canje de coins"
                      type="text"
                      readOnly={this.props.readOnly}
                      value={values.coinsByQuestions}
                      onChange={this.changeModeCoins}
                      style={{ border: '1px solid', borderRadius: '8px', padding: '8px 16px'}}
                    >
                      <MenuItem value={1} key={1}>
                        <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                          <b>Al completar actividad</b>
                          <br />
                          <small style={{ fontWeight: 400, color: '#666' }}>
                            Los participantes obtendrán puntos al concluir toda la misión, ideal para metas globales.
                          </small>
                          <br />
                          <small style={{ fontWeight: 400, color: '#666' }}>
                            exitosamente. Ideal para tareas enfocadas en la finalización de un objetivo general.
                          </small>
                        </Typography>
                      </MenuItem>
                      <MenuItem value={2} key={2}>
                        <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                          <b>Al completar actividad y responder correctamente todo el quiz</b>
                          <br />
                          <small style={{ fontWeight: 400, color: '#666' }}>
                            Otorga puntos al terminar la misión y acertar todas las preguntas del quiz. Perfecto
                          </small>
                          <br />
                          <small style={{ fontWeight: 400, color: '#666' }}>
                            para validar el conocimiento obtenido.
                          </small>
                        </Typography>
                      </MenuItem>
                      <MenuItem value={3} key={3}>
                        <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                          <b>Al completar actividad y por cada respuesta correcta de quiz</b>
                          <br />
                          <small style={{ fontWeight: 400, color: '#666' }}>
                            Los puntos se asignan por cada pregunta respondida correctamente dentro de la 
                          </small>
                          <br />
                          <small style={{ fontWeight: 400, color: '#666' }}>
                            misión. Esta opción fomenta la participación activa y el aprendizaje continuo.
                          </small>
                        </Typography>
                      </MenuItem>
                    </Select>
                    {
                      touched.coinsByQuestions && (errors.coinsByQuestions) && <FormHelperText>{ errors.coinsByQuestions }</FormHelperText>
                    }
                  </FormControl>
                </div>
                {
                  this.state.coinsByQuestions == false &&
                  <div className="col-lg-6 col-sm-6 col-12">
                    <FormControl fullWidth>
                      <span className="inputTitle">Puntos</span>
                      <span className="inputSubtitle">
                        Establece la cantidad de puntos que se otorgarán si el usuario completa la misión exitosamente
                      </span>
                      <TextField
                          fullWidth
                          id="outlined-text-input"
                          type="number"
                          name="amount"
                          inputProps={{ readOnly: this.props.readOnly }}
                          onBlur={handleBlur}
                          error={errors.amount && touched.amount}
                          helpertext={touched.amount && (errors.amount)}
                          className={errors.amount && touched.amount && "error"}
                          value={values.amount}
                          onChange={handleChange}
                          min={0}
                          label="0"
                        />                  
                    </FormControl>
                  </div>
                }
              </div>

              {
                this.state.have_question &&
                <>
                  <div className='d-flex align-top mb-1'>
                    <div className="d-flex ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M13.5 14.538C13.7067 14.538 13.8883 14.4597 14.045 14.303C14.2023 14.1457 14.281 13.964 14.281 13.758C14.281 13.5513 14.2023 13.3697 14.045 13.213C13.8877 13.0563 13.706 12.9777 13.5 12.977C13.2933 12.977 13.1117 13.0557 12.955 13.213C12.7983 13.3703 12.7197 13.552 12.719 13.758C12.719 13.9647 12.7977 14.1463 12.955 14.303C13.1117 14.4597 13.2933 14.538 13.5 14.538ZM13.058 11.723H13.942C13.968 11.3037 14.034 10.988 14.14 10.776C14.2467 10.564 14.5027 10.268 14.908 9.888C15.3307 9.504 15.6253 9.16067 15.792 8.858C15.9587 8.55667 16.042 8.21033 16.042 7.819C16.042 7.14567 15.802 6.58467 15.322 6.136C14.842 5.68667 14.2347 5.462 13.5 5.462C12.9447 5.462 12.4513 5.612 12.02 5.912C11.5887 6.212 11.2603 6.62067 11.035 7.138L11.846 7.496C12.0347 7.10533 12.2647 6.812 12.536 6.616C12.8067 6.42067 13.128 6.323 13.5 6.323C13.9767 6.323 14.3723 6.46433 14.687 6.747C15.0003 7.02967 15.157 7.39467 15.157 7.842C15.157 8.114 15.081 8.367 14.929 8.601C14.7763 8.83433 14.514 9.116 14.142 9.446C13.7207 9.814 13.4347 10.1517 13.284 10.459C13.1333 10.7657 13.058 11.187 13.058 11.723ZM8.115 17C7.655 17 7.271 16.846 6.963 16.538C6.65433 16.2293 6.5 15.845 6.5 15.385V4.615C6.5 4.155 6.65433 3.771 6.963 3.463C7.271 3.15433 7.655 3 8.115 3H18.885C19.345 3 19.729 3.15433 20.037 3.463C20.3457 3.771 20.5 4.155 20.5 4.615V15.385C20.5 15.845 20.346 16.2293 20.038 16.538C19.7293 16.846 19.345 17 18.885 17H8.115ZM8.115 16H18.885C19.0383 16 19.1793 15.936 19.308 15.808C19.436 15.6793 19.5 15.5383 19.5 15.385V4.615C19.5 4.46167 19.436 4.32067 19.308 4.192C19.1793 4.064 19.0383 4 18.885 4H8.115C7.96167 4 7.82067 4.064 7.692 4.192C7.564 4.32067 7.5 4.46167 7.5 4.615V15.385C7.5 15.5383 7.564 15.6793 7.692 15.808C7.82067 15.936 7.96167 16 8.115 16ZM5.115 20C4.655 20 4.271 19.846 3.963 19.538C3.65433 19.2293 3.5 18.845 3.5 18.385V6.615H4.5V18.385C4.5 18.5383 4.564 18.6793 4.692 18.808C4.82067 18.936 4.96167 19 5.115 19H16.885V20H5.115Z" fill="#FF4F00"/>
                      </svg>
                      <span className='missionSecondaryTitle'>5. Configuración de Quiz</span>
                      {
                        (this.state.have_question && !this.props.readOnly) &&
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M17.25 17.25C13.008 17.25 11.3565 12.4425 11.2882 12.237C11.2755 12.1988 9.906 8.25 6.75 8.25C4.68225 8.25 3 9.93225 3 12C3 14.0677 4.68225 15.75 6.75 15.75C7.941 15.75 9.00975 15.201 9.92775 14.118L11.0722 15.0878C9.873 16.5023 8.379 17.25 6.75 17.25C3.855 17.25 1.5 14.895 1.5 12C1.5 9.105 3.855 6.75 6.75 6.75C10.992 6.75 12.6435 11.5575 12.7118 11.763C12.7245 11.8012 14.094 15.75 17.25 15.75C19.3177 15.75 21 14.0677 21 12C21 9.93225 19.3177 8.25 17.25 8.25C16.059 8.25 14.9903 8.799 14.0723 9.882L12.9277 8.91225C14.127 7.49775 15.621 6.75 17.25 6.75C20.145 6.75 22.5 9.105 22.5 12C22.5 14.895 20.145 17.25 17.25 17.25Z" fill="#FF4F00"/>
                        </svg>
                      }
                      {
                        (this.state.have_question && !this.props.readOnly ) &&
                        <span className='missionSecondaryTitle'>Intentos ilimitados (Opcional)</span>
                      }
                      {
                        (this.state.have_question && !this.props.readOnly ) && 
                        <Checkbox
                          checked={this.state.canRepeat}
                          onChange={this.changeRepeatMission}
                        />
                      }
                    </div>
                  </div>
                  {
                    !this.props.readOnly &&
                    <div>
                      <span className="inputSubtitle">
                        Define preguntas clave para evaluar la comprensión y el desempeño de los usuarios en la misión. Puedes optar por incluir evaluaciones y establecer el número de intentos permitidos.
                      </span>
                    </div>
                  }
                </>
              }

              

              {
                this.state.have_question &&
                <div>
                  {
                    questionsLocked && !this.props.readOnly &&
                    <div className="alert mt-2" style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '6px', padding: '10px 16px', color: '#856404' }}>
                      <strong>Edición de preguntas deshabilitada:</strong> esta misión ya fue completada por al menos un usuario. Para preservar la integridad de los resultados, las preguntas y respuestas no pueden modificarse.
                    </div>
                  }
                  {
                    !this.props.readOnly && !questionsLocked &&
                    <div>
                    <div className="row mb-md-3 mt-2">
                      <div className="col-lg-6 col-sm-12 col-6">
                        <span className="inputTitle">Título de la pregunta</span>
                        <br />
                        <span className="inputSubtitle">
                          Asigna un título distintivo a la pregunta que refleje claramente el tema o el contenido a evaluar.
                        </span>
                        <TextField
                            fullWidth
                            id="outlined-text-input"
                            type="text"
                            name="questionName"
                            value={this.state.question}
                            onChange={event => this.typeAnswerText(event, 1)}
                          />
                      </div>
                      <div className="col-lg-6 col-sm-12 col-6">
                        <FormControl fullWidth>
                          <span className="inputTitle">Formato de la Pregunta</span>
                          <span className="inputSubtitle">
                            Elige el formato en el que se presentará la pregunta, como opción múltiple o como pregunta abierta.
                          </span>
                          <Select
                            fullWidth
                            id="outlined-text-input"
                            label="Tipo de pregunta"
                            type="text"
                            value={this.state.type_question}
                            onChange={this.questionTypeChange}
                            style={{ border: '1px solid', borderRadius: '8px', padding: '8px 16px'}}
                          >
                            <MenuItem value="abierta" selected={ this.state.type_question == 'abierta' ? true : false }> 
                              <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <b>Pregunta abierta</b>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  Permite contestar de forma abierta. Asegúrate de que la respuesta coincida con el
                                </small>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  contenido registrado en el sistema.
                                </small>
                              </Typography>
                            </MenuItem>
                            <MenuItem value="cerrada" selected={this.state.type_question == 'cerrada' ? true : false}> 
                              <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <b>Opción múltiple</b>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  Selecciona una respuesta entre múltiples opciones. La respuesta debe coincidir con
                                </small>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                 la correcta para ser considerada válida.
                                </small>
                              </Typography>
                            </MenuItem>
                            <MenuItem value="abiertaEncuesta" selected={this.state.type_question == 'abiertaEncuesta' ? true : false}> 
                              <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <b>Pregunta abierta para encuesta</b>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  Pregunta 100% abierta (opinión). No hay respuestas buenas o malas; cualquier
                                </small>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  respuesta es válida.
                                </small>
                              </Typography>
                            </MenuItem>
                            <MenuItem value="cerradaEncuesta" selected={this.state.type_question == 'cerradaEncuesta' ? true : false}> 
                              <Typography variant="subtitle1" component="div" sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <b>Opción multiple para encuesta</b>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  Selecciona una respuesta entre múltiples opciones. No hay respuestas buenas o
                                </small>
                                <br />
                                <small style={{ fontWeight: 400, color: '#666' }}>
                                  malas; cualquier respuesta es válida.
                                </small>
                              </Typography>
                            </MenuItem>
                          </Select>
                          {errors.description && touched.description && (<FormHelperText error={errors.description && touched.description}>{errors.description}</FormHelperText>)}
                        </FormControl>     
                      </div>
                      <div className="row col-lg-12 col-sm-12 col-12">
                        {
                          (this.state.type_question == 'cerrada' || this.state.type_question == 'cerradaEncuesta') &&
                          <div className="col-lg-5 col-sm-5 col-5 mt-3">
                            <span className="inputTitle">Respuesta</span>
                            <br />
                            <span className="inputSubtitle">
                              Ingresa la opción de respuesta para la pregunta formulada. Si es una respuesta correcta, marca la casilla para validarla como tal.
                            </span>
                            <TextField
                              fullWidth
                              id="outlined-text-input"
                              type="text"
                              className="mt-3"
                              value={this.state.answer}
                              onChange={event => this.typeAnswerText(event, 2)}
                            />
                          </div>
                        }
                        {
                          (this.state.type_question == 'abierta' || this.state.type_question == 'abiertaEncuesta')&&
                          <div className="col-lg-8 col-sm-12 col-8 mt-3">
                            <span className="inputTitle">Respuesta</span>
                            <br />
                            <span className="inputSubtitle">
                              Ingresa la opción de respuesta para la pregunta formulada. Si es una respuesta correcta, marca la casilla para validarla como tal.
                            </span>
                            <TextField
                              fullWidth
                              id="outlined-text-input"
                              type="text"
                              className="mt-3"
                              value={this.state.answer}
                              onChange={event => this.typeAnswerText(event, 2)}
                            />
                          </div>
                        }
                        {
                          (this.state.coinsByQuestions && (this.state.type_question == 'cerrada' || this.state.type_question == 'cerradaEncuesta')) &&
                          <div className="col-lg-3 col-sm-12 col-12 mt-3">
                            <span className="inputTitle">Puntos</span>
                            <br />
                            <span className="inputSubtitle">
                              Establece la cantidad de puntos.
                            </span>
                            <TextField
                              fullWidth
                              id="outlined-text-input"
                              type="number"
                              className="mt-3"
                              value={this.state.question_coins}
                              onChange={event => this.typeAnswerText(event, 3)}
                            />
                          </div>
                        }
                        {
                          (this.state.coinsByQuestions && (this.state.type_question == 'abierta' || this.state.type_question == 'abiertaEncuesta')) &&
                          <div className="col-lg-4 col-sm-12 col-12 mt-3">
                            <span className="inputTitle">Puntos</span>
                            <br />
                            <span className="inputSubtitle">
                              Establece la cantidad de puntos.
                            </span>
                            <TextField
                              fullWidth
                              id="outlined-text-input"
                              type="number"
                              className="mt-3"
                              value={this.state.question_coins}
                              onChange={event => this.typeAnswerText(event, 3)}
                            />
                          </div>
                        }
                        {
                          (this.state.type_question == 'cerrada') &&
                          <div className="d-flex align-bottom col-lg-4 col-sm-4 col-4">
                          {
                            this.state.show_answer_correct &&
                              <FormControlLabel
                                label="Respuesta correcta"
                                control={
                                  <Checkbox
                                    checked={this.state.answer_is_correct}
                                    onChange={this.changeCorrect}
                                  />
                                }
                              />
                          }
                        </div>
                        }
                        {
                          (this.state.type_question == 'cerrada' || this.state.type_question == 'cerradaEncuesta') &&
                          <div className="col-lg-2 col-sm-2 col-2 mt-3 d-inline">
                            <button className="d-flex missionButton mt-8" type="button" 
                                onClick={this.addAnswer}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10.8332 2.91663C10.8332 2.58511 10.7015 2.26716 10.4671 2.03274C10.2326 1.79832 9.91469 1.66663 9.58317 1.66663C9.25165 1.66663 8.93371 1.79832 8.69929 2.03274C8.46487 2.26716 8.33317 2.58511 8.33317 2.91663V8.33329H2.9165C2.58498 8.33329 2.26704 8.46499 2.03262 8.69941C1.7982 8.93383 1.6665 9.25177 1.6665 9.58329C1.6665 9.91481 1.7982 10.2328 2.03262 10.4672C2.26704 10.7016 2.58498 10.8333 2.9165 10.8333H8.33317V16.25C8.33317 16.5815 8.46487 16.8994 8.69929 17.1338C8.93371 17.3683 9.25165 17.5 9.58317 17.5C9.91469 17.5 10.2326 17.3683 10.4671 17.1338C10.7015 16.8994 10.8332 16.5815 10.8332 16.25V10.8333H16.2498C16.5814 10.8333 16.8993 10.7016 17.1337 10.4672C17.3681 10.2328 17.4998 9.91481 17.4998 9.58329C17.4998 9.25177 17.3681 8.93383 17.1337 8.69941C16.8993 8.46499 16.5814 8.33329 16.2498 8.33329H10.8332V2.91663Z" fill="white"/>
                              </svg>
                              Agregar respuesta
                            </button>  
                          </div>
                        }
                      </div>
                    </div>
                    {
                      (this.state.type_question == 'cerrada' || this.state.type_question == 'cerradaEncuesta') &&
                      <div className="mt-3">
                        <div>
                          <span className="missionSecondaryTitle">Respuestas guardadas</span>
                          <br />
                          <span className="inputSubtitle">
                            Aquí se listan las respuestas establecidas para cada pregunta. Tienes la opción de eliminar o editar las respuestas para asegurar que la evaluación sea precisa y relevante
                          </span>
                        </div>
                        {
                          this.state.answers.length != 0 ?
                          <div className="row mt-2">
                            {
                              this.state.answers.map(answer =>
                                <div className="col-2 col-lg-2 col-sm-6 d-flex bg-light mr-1" key={answer.desc}>
                                  {answer.desc} {answer.correct ? <span> - Correcto</span> : ''}
                                  <svg xmlns="http://www.w3.org/2000/svg" width="0.8em" height="1em" className="ml-2"
                                    viewBox="0 0 512 512" onClick={() => this.editAnswer(answer.desc)} role='button'>
                                    <path d="M373.1 24.97C401.2-3.147 446.8-3.147 474.9 24.97L487 37.09C515.1 65.21 515.1 110.8 487 138.9L289.8 336.2C281.1 344.8 270.4 351.1 258.6 354.5L158.6 383.1C150.2 385.5 141.2 383.1 135 376.1C128.9 370.8 126.5 361.8 128.9 353.4L157.5 253.4C160.9 241.6 167.2 230.9 175.8 222.2L373.1 24.97zM440.1 58.91C431.6 49.54 416.4 49.54 407 58.91L377.9 88L424 134.1L453.1 104.1C462.5 95.6 462.5 80.4 453.1 71.03L440.1 58.91zM203.7 266.6L186.9 325.1L245.4 308.3C249.4 307.2 252.9 305.1 255.8 302.2L390.1 168L344 121.9L209.8 256.2C206.9 259.1 204.8 262.6 203.7 266.6zM200 64C213.3 64 224 74.75 224 88C224 101.3 213.3 112 200 112H88C65.91 112 48 129.9 48 152V424C48 446.1 65.91 464 88 464H360C382.1 464 400 446.1 400 424V312C400 298.7 410.7 288 424 288C437.3 288 448 298.7 448 312V424C448 472.6 408.6 512 360 512H88C39.4 512 0 472.6 0 424V152C0 103.4 39.4 64 88 64H200z" />
                                  </svg>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"
                                     className="ml-2" onClick={() => this.deleteAnswer(answer.desc)} role='button'>
                                    <path d="M7 3.5H9C9 3.23478 8.89464 2.98043 8.70711 2.79289C8.51957 2.60536 8.26522 2.5 8 2.5C7.73478 2.5 7.48043 2.60536 7.29289 2.79289C7.10536 2.98043 7 3.23478 7 3.5ZM6 3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5C8.53043 1.5 9.03914 1.71071 9.41421 2.08579C9.78929 2.46086 10 2.96957 10 3.5H14C14.1326 3.5 14.2598 3.55268 14.3536 3.64645C14.4473 3.74021 14.5 3.86739 14.5 4C14.5 4.13261 14.4473 4.25979 14.3536 4.35355C14.2598 4.44732 14.1326 4.5 14 4.5H13.436L12.231 13.338C12.1493 13.9369 11.8533 14.486 11.3979 14.8835C10.9425 15.281 10.3585 15.5 9.754 15.5H6.246C5.64152 15.5 5.05751 15.281 4.6021 14.8835C4.14669 14.486 3.85073 13.9369 3.769 13.338L2.564 4.5H2C1.86739 4.5 1.74021 4.44732 1.64645 4.35355C1.55268 4.25979 1.5 4.13261 1.5 4C1.5 3.86739 1.55268 3.74021 1.64645 3.64645C1.74021 3.55268 1.86739 3.5 2 3.5H6ZM7 7C7 6.86739 6.94732 6.74021 6.85355 6.64645C6.75979 6.55268 6.63261 6.5 6.5 6.5C6.36739 6.5 6.24021 6.55268 6.14645 6.64645C6.05268 6.74021 6 6.86739 6 7V12C6 12.1326 6.05268 12.2598 6.14645 12.3536C6.24021 12.4473 6.36739 12.5 6.5 12.5C6.63261 12.5 6.75979 12.4473 6.85355 12.3536C6.94732 12.2598 7 12.1326 7 12V7ZM9.5 6.5C9.63261 6.5 9.75979 6.55268 9.85355 6.64645C9.94732 6.74021 10 6.86739 10 7V12C10 12.1326 9.94732 12.2598 9.85355 12.3536C9.75979 12.4473 9.63261 12.5 9.5 12.5C9.36739 12.5 9.24021 12.4473 9.14645 12.3536C9.05268 12.2598 9 12.1326 9 12V7C9 6.86739 9.05268 6.74021 9.14645 6.64645C9.24021 6.55268 9.36739 6.5 9.5 6.5ZM4.76 13.203C4.80908 13.5623 4.98664 13.8916 5.25984 14.1301C5.53304 14.3685 5.88337 14.5 6.246 14.5H9.754C10.1168 14.5002 10.4674 14.3689 10.7408 14.1304C11.0142 13.8919 11.1919 13.5625 11.241 13.203L12.427 4.5H3.573L4.76 13.203Z" fill="black"/>
                                  </svg>
                                </div>
                              )
                            }
                          </div> : 
                          <div className="row bg-light mt-2">
                            <div className="col-12 col-sm-12 col-lg-12">
                              <span>
                                Sin respuestas  guardadas. Comienza a añadir respuestas para que se muestren en esta sección.
                              </span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div className="mt-3 row">
                      <div className="col-12 col-lg-12 col-sm-12">
                        <button className='missionButton w-100' type="button"
                          onClick={() => { this.addQuestion() }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M10.8332 2.91663C10.8332 2.58511 10.7015 2.26716 10.4671 2.03274C10.2326 1.79832 9.91469 1.66663 9.58317 1.66663C9.25165 1.66663 8.93371 1.79832 8.69929 2.03274C8.46487 2.26716 8.33317 2.58511 8.33317 2.91663V8.33329H2.9165C2.58498 8.33329 2.26704 8.46499 2.03262 8.69941C1.7982 8.93383 1.6665 9.25177 1.6665 9.58329C1.6665 9.91481 1.7982 10.2328 2.03262 10.4672C2.26704 10.7016 2.58498 10.8333 2.9165 10.8333H8.33317V16.25C8.33317 16.5815 8.46487 16.8994 8.69929 17.1338C8.93371 17.3683 9.25165 17.5 9.58317 17.5C9.91469 17.5 10.2326 17.3683 10.4671 17.1338C10.7015 16.8994 10.8332 16.5815 10.8332 16.25V10.8333H16.2498C16.5814 10.8333 16.8993 10.7016 17.1337 10.4672C17.3681 10.2328 17.4998 9.91481 17.4998 9.58329C17.4998 9.25177 17.3681 8.93383 17.1337 8.69941C16.8993 8.46499 16.5814 8.33329 16.2498 8.33329H10.8332V2.91663Z" fill="white"/>
                            </svg>
                            Agregar pregunta
                        </button>
                      </div>
                    </div>

                    </div>
                  }
                  
                  <div className="mt-3">
                      <div>
                        <span className="missionSecondaryTitle">Preguntas guardadas</span>
                        <br />
                        <span className="inputSubtitle">
                          Visualiza y gestiona las preguntas añadidas a tu misión. Modifica o elimina según sea necesario.
                        </span>
                      </div>
                      {
                        this.state.questions.length != 0 ?
                        <div className="row mt-2">
                          {
                            this.state.questions.map(question =>
                              <div className="col-2 col-lg-2 col-sm-6 d-flex bg-light mr-1" key={question.desc}>
                                {
                                  (question.type == 'abierta' || question.type == 'abiertaEncuesta')?
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none" className="mr-2">
                                    <path d="M8.00016 3.83337V9.16671V3.83337ZM8.00016 3.83337H5.3335H8.00016ZM8.00016 3.83337H10.6668H8.00016Z" fill="#FF4F00"/>
                                    <path d="M8.00016 3.83337V9.16671M8.00016 3.83337H5.3335M8.00016 3.83337H10.6668" stroke="#FF4F00" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M14 7.5V11.1667C14 11.5203 13.8595 11.8594 13.6095 12.1095C13.3594 12.3595 13.0203 12.5 12.6667 12.5H3.33333C2.97971 12.5 2.64057 12.3595 2.39052 12.1095C2.14048 11.8594 2 11.5203 2 11.1667V7.5M14 5.5V1.83333C14 1.47971 13.8595 1.14057 13.6095 0.890524C13.3594 0.640476 13.0203 0.5 12.6667 0.5H3.33333C2.97971 0.5 2.64057 0.640476 2.39052 0.890524C2.14048 1.14057 2 1.47971 2 1.83333V5.5M13 7.5V5.5H15V7.5H13ZM1 7.5V5.5H3V7.5H1Z" stroke="#FF4F00" stroke-linejoin="round"/>
                                  </svg> :
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" className="m4-2">
                                    <path d="M4 13.5H2C1.73486 13.4997 1.48066 13.3943 1.29319 13.2068C1.10571 13.0193 1.00026 12.7651 1 12.5V10.5H2V12.5H4V13.5ZM1 6.5H2V8.5H1V6.5ZM13 4.5H12V2.5H10V1.5H12C12.2651 1.50026 12.5193 1.60571 12.7068 1.79319C12.8943 1.98066 12.9997 2.23486 13 2.5V4.5ZM6 1.5H8V2.5H6V1.5ZM2 4.5H1V2.5C1.00026 2.23486 1.10571 1.98066 1.29319 1.79319C1.48066 1.60571 1.73486 1.50026 2 1.5H4V2.5H2V4.5ZM13.5 16.5C13.4343 16.5001 13.3693 16.4872 13.3086 16.462C13.248 16.4369 13.1929 16.4 13.1465 16.3535L10.0775 13.2845L8.416 15.7775C8.36335 15.8565 8.2893 15.9188 8.20253 15.9573C8.11575 15.9957 8.01983 16.0087 7.92596 15.9946C7.8321 15.9805 7.74417 15.9401 7.67246 15.8779C7.60075 15.8157 7.54822 15.7344 7.521 15.6435L4.521 5.6435C4.49509 5.55704 4.49306 5.46517 4.51514 5.37765C4.53722 5.29013 4.58257 5.21022 4.6464 5.1464C4.71022 5.08257 4.79013 5.03722 4.87765 5.01514C4.96517 4.99306 5.05704 4.99509 5.1435 5.021L15.1435 8.021C15.2344 8.04822 15.3157 8.10075 15.3779 8.17246C15.4401 8.24417 15.4805 8.3321 15.4946 8.42596C15.5087 8.51983 15.4957 8.61575 15.4573 8.70253C15.4188 8.7893 15.3565 8.86335 15.2775 8.916L12.7845 10.5775L15.8535 13.6465C15.9472 13.7403 15.9999 13.8674 15.9999 14C15.9999 14.1326 15.9472 14.2597 15.8535 14.3535L13.8535 16.3535C13.8071 16.4 13.752 16.4369 13.6914 16.462C13.6307 16.4872 13.5657 16.5001 13.5 16.5ZM13.5 15.293L14.793 14L11.2155 10.4225L13.8385 8.6735L5.746 6.246L8.1735 14.3385L9.9225 11.7155L13.5 15.293Z" fill="#FF4F00"/>
                                  </svg>
                                }
                                {question.desc}
                                {
                                  !this.props.readOnly && !questionsLocked &&
                                  <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="0.8em" height="1em" className="ml-2"
                                      viewBox="0 0 512 512" onClick={() => this.editQuestion(question.desc)} role='button'>
                                      <path d="M373.1 24.97C401.2-3.147 446.8-3.147 474.9 24.97L487 37.09C515.1 65.21 515.1 110.8 487 138.9L289.8 336.2C281.1 344.8 270.4 351.1 258.6 354.5L158.6 383.1C150.2 385.5 141.2 383.1 135 376.1C128.9 370.8 126.5 361.8 128.9 353.4L157.5 253.4C160.9 241.6 167.2 230.9 175.8 222.2L373.1 24.97zM440.1 58.91C431.6 49.54 416.4 49.54 407 58.91L377.9 88L424 134.1L453.1 104.1C462.5 95.6 462.5 80.4 453.1 71.03L440.1 58.91zM203.7 266.6L186.9 325.1L245.4 308.3C249.4 307.2 252.9 305.1 255.8 302.2L390.1 168L344 121.9L209.8 256.2C206.9 259.1 204.8 262.6 203.7 266.6zM200 64C213.3 64 224 74.75 224 88C224 101.3 213.3 112 200 112H88C65.91 112 48 129.9 48 152V424C48 446.1 65.91 464 88 464H360C382.1 464 400 446.1 400 424V312C400 298.7 410.7 288 424 288C437.3 288 448 298.7 448 312V424C448 472.6 408.6 512 360 512H88C39.4 512 0 472.6 0 424V152C0 103.4 39.4 64 88 64H200z" />
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"
                                      className="ml-2" onClick={() => this.deleteQuestion(question.desc)} role='button'>
                                      <path d="M7 3.5H9C9 3.23478 8.89464 2.98043 8.70711 2.79289C8.51957 2.60536 8.26522 2.5 8 2.5C7.73478 2.5 7.48043 2.60536 7.29289 2.79289C7.10536 2.98043 7 3.23478 7 3.5ZM6 3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5C8.53043 1.5 9.03914 1.71071 9.41421 2.08579C9.78929 2.46086 10 2.96957 10 3.5H14C14.1326 3.5 14.2598 3.55268 14.3536 3.64645C14.4473 3.74021 14.5 3.86739 14.5 4C14.5 4.13261 14.4473 4.25979 14.3536 4.35355C14.2598 4.44732 14.1326 4.5 14 4.5H13.436L12.231 13.338C12.1493 13.9369 11.8533 14.486 11.3979 14.8835C10.9425 15.281 10.3585 15.5 9.754 15.5H6.246C5.64152 15.5 5.05751 15.281 4.6021 14.8835C4.14669 14.486 3.85073 13.9369 3.769 13.338L2.564 4.5H2C1.86739 4.5 1.74021 4.44732 1.64645 4.35355C1.55268 4.25979 1.5 4.13261 1.5 4C1.5 3.86739 1.55268 3.74021 1.64645 3.64645C1.74021 3.55268 1.86739 3.5 2 3.5H6ZM7 7C7 6.86739 6.94732 6.74021 6.85355 6.64645C6.75979 6.55268 6.63261 6.5 6.5 6.5C6.36739 6.5 6.24021 6.55268 6.14645 6.64645C6.05268 6.74021 6 6.86739 6 7V12C6 12.1326 6.05268 12.2598 6.14645 12.3536C6.24021 12.4473 6.36739 12.5 6.5 12.5C6.63261 12.5 6.75979 12.4473 6.85355 12.3536C6.94732 12.2598 7 12.1326 7 12V7ZM9.5 6.5C9.63261 6.5 9.75979 6.55268 9.85355 6.64645C9.94732 6.74021 10 6.86739 10 7V12C10 12.1326 9.94732 12.2598 9.85355 12.3536C9.75979 12.4473 9.63261 12.5 9.5 12.5C9.36739 12.5 9.24021 12.4473 9.14645 12.3536C9.05268 12.2598 9 12.1326 9 12V7C9 6.86739 9.05268 6.74021 9.14645 6.64645C9.24021 6.55268 9.36739 6.5 9.5 6.5ZM4.76 13.203C4.80908 13.5623 4.98664 13.8916 5.25984 14.1301C5.53304 14.3685 5.88337 14.5 6.246 14.5H9.754C10.1168 14.5002 10.4674 14.3689 10.7408 14.1304C11.0142 13.8919 11.1919 13.5625 11.241 13.203L12.427 4.5H3.573L4.76 13.203Z" fill="black"/>
                                    </svg>
                                  </div>
                                }
                              </div>
                            )
                          }
                        </div> : 
                        <div className="row bg-light mt-2">
                          <div className="col-12 col-sm-12 col-lg-12">
                            <span>
                              No se han añadido preguntas a esta misión aún. Utiliza el formulario de arriba para empezar a crear y guardar tus preguntas.
                            </span>
                          </div>
                        </div>
                      }
                    </div>

                </div>
              }

              <div className='d-none align-top mb-1 mt-4'>
                <div className="d-flex ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18.134 11C18.715 16.375 21 18 21 18H3C3 18 6 15.867 6 8.4C6 6.703 6.632 5.075 7.757 3.875C8.883 2.675 10.41 2 12 2C12.337 2 12.672 2.03 13 2.09M13.73 21C13.5544 21.3033 13.3021 21.5552 12.9985 21.7302C12.6948 21.9053 12.3505 21.9974 12 21.9974C11.6495 21.9974 11.3052 21.9053 11.0015 21.7302C10.6979 21.5552 10.4456 21.3033 10.27 21M19 8C19.7956 8 20.5587 7.68393 21.1213 7.12132C21.6839 6.55871 22 5.79565 22 5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2C18.2044 2 17.4413 2.31607 16.8787 2.87868C16.3161 3.44129 16 4.20435 16 5C16 5.79565 16.3161 6.55871 16.8787 7.12132C17.4413 7.68393 18.2044 8 19 8Z" stroke="#FF4F00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span className='missionSecondaryTitle'>6. ¿Enviar notificación push cuando esté disponible?</span>
                  <Checkbox
                      checked={this.state.sendNotification}
                      onChange={this.changeNotification}
                    />
                </div>
              </div>
              <div className="d-none">
                <span className="inputSubtitle">
                  Activa esta opción para que los participantes reciban una notificación push en su dispositivo cuando la misión esté disponible.
                </span>
              </div>

              {this.props.readOnly &&
                <div className="row justify-content-center mt-4 pl-4">
                  <button className='btn mr-3 missionButton' type="button"
                    onClick={() => { this.handleCancel(values) }}>
                      Regresar
                  </button>
                </div>}
              {(!this.props.readOnly && (<div className="row justify-content-end mt-4">
                <button disabled={this.state.isSubmitting} className='btn mr-3 missionButton' type="button" onClick={() => { this.handleCancel(values) }} >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M3.99994 9.99997L3.29294 10.707L2.58594 9.99997L3.29294 9.29297L3.99994 9.99997ZM20.9999 18C20.9999 18.2652 20.8946 18.5195 20.707 18.7071C20.5195 18.8946 20.2652 19 19.9999 19C19.7347 19 19.4804 18.8946 19.2928 18.7071C19.1053 18.5195 18.9999 18.2652 18.9999 18H20.9999ZM8.29294 15.707L3.29294 10.707L4.70694 9.29297L9.70694 14.293L8.29294 15.707ZM3.29294 9.29297L8.29294 4.29297L9.70694 5.70697L4.70694 10.707L3.29294 9.29297ZM3.99994 8.99997H13.9999V11H3.99994V8.99997ZM20.9999 16V18H18.9999V16H20.9999ZM13.9999 8.99997C15.8565 8.99997 17.6369 9.73747 18.9497 11.0502C20.2624 12.363 20.9999 14.1435 20.9999 16H18.9999C18.9999 14.6739 18.4732 13.4021 17.5355 12.4644C16.5978 11.5268 15.326 11 13.9999 11V8.99997Z" fill="white"/>
                  </svg>
                  Cancelar
                </button>
                <button disabled={this.state.isSubmitting} className='btn missionButton' style={{ backgroundColor: '#28a745', color: 'white' }} type="submit" >
                  {this.state.isSubmitting && <span className="spinner-border spinner-border-sm"></span>}
                  {!this.state.isSubmitting && 
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g clip-path="url(#clip0_2083_7455)">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.6 4C7.17565 4 6.76869 4.16857 6.46863 4.46863C6.16857 4.76869 6 5.17565 6 5.6V18.4C6 18.8243 6.16857 19.2313 6.46863 19.5314C6.76869 19.8314 7.17565 20 7.6 20H17.2C17.6243 20 18.0313 19.8314 18.3314 19.5314C18.6314 19.2313 18.8 18.8243 18.8 18.4V7.5312C18.7999 7.10689 18.6313 6.69999 18.3312 6.4L16.4 4.4688C16.1 4.16872 15.6931 4.00009 15.2688 4H7.6ZM7.6 5.6H15.2688L17.2 7.5312V18.4H7.6V5.6ZM15.7904 11.0344C15.8668 10.9606 15.9278 10.8723 15.9697 10.7747C16.0116 10.6771 16.0337 10.5721 16.0346 10.4659C16.0355 10.3597 16.0153 10.2544 15.9751 10.156C15.9348 10.0577 15.8754 9.9684 15.8003 9.89328C15.7252 9.81817 15.6359 9.75877 15.5376 9.71854C15.4392 9.67832 15.3339 9.65808 15.2277 9.659C15.1215 9.65992 15.0165 9.68199 14.9189 9.72392C14.8213 9.76585 14.733 9.82679 14.6592 9.9032L11.2656 13.2976L10.1336 12.1656C9.98272 12.0199 9.78064 11.9392 9.57088 11.9411C9.36112 11.9429 9.16047 12.027 9.01215 12.1753C8.86382 12.3237 8.77968 12.5243 8.77786 12.7341C8.77604 12.9438 8.85667 13.1459 9.0024 13.2968L10.6424 14.9376C10.7241 15.0194 10.8211 15.0842 10.9279 15.1285C11.0347 15.1727 11.1492 15.1955 11.2648 15.1955C11.3804 15.1955 11.4949 15.1727 11.6017 15.1285C11.7085 15.0842 11.8055 15.0194 11.8872 14.9376L15.7904 11.0344Z" fill="white"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_2083_7455">
                            <rect width="24" height="24" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                      <span>Guardar misión</span>
                    </>
                  }
                </button>
              </div>))}
            </form>
          )
        }}
      </Formik>
    );
  }
}

export default DataDisplayer;